<template>
  <div>
    <van-nav-bar
      title="邮箱"
      left-text=""
      left-arrow
      @click-left="$router.push('/member/information')"
    />
    <van-form @submit="setEmail" id="changeEmail">
      <van-field
        v-model="inputEmail"
        name="newEmail"
        label="请输入邮箱"
        placeholder="请输入您要更改的邮箱"
        :rules="[{ required: true }]"
      />
      <van-field
        v-model="inputEmailCode"
        center
        clearable
        label="短信验证码"
        placeholder="请输入您新邮箱收到的验证码"
        :rules="[{ required: true }]"
      >
        <template #button>
          <van-button
            native-type="button"
            size="small"
            plain
            color="#D02E27"
            @click="getEmailCode"
            :disabled="disabled4"
            >{{ emailCodeText }}</van-button
          >
        </template>
      </van-field>
      <div style="margin: 16px">
        <van-button
          round
          block
          size="small"
          color="#D02E27"
          style="height: 50px"
          native-type="submit"
          class="change_email_btn"
        >
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { Toast } from "vant";
import JSEncrypt from "jsencrypt/bin/jsencrypt";
export default {
  name: "BindEmail",
  data() {
    return {
      emailCodeText: "获取验证码",
      disabled4: false,
      inputEmailCode: "",
      inputEmail: "",
      encryptedPhone: "",
    };
  },
  computed: {
    // phone:function () {
    //   return this.$store.state.phone
    // },
    // user:function () {
    //   return this.$store.state.user
    // }
  },
  methods: {
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },

    getEmailCode() {
      let that = this;
      if (that.inputLoginPhone == "") {
        that.$message.error("请输入验证码");
      }
      clearInterval(window.timer2);
      let publicKey = localStorage.getItem("encript_public_key");
      let userPhone = that.encryptedPhone.toString();
      let inputPhone = that.encryptMessage(userPhone, publicKey);
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "modifyInfo_code_e",
            token: sessionStorage.getItem("token"),
            info: inputPhone,
            type: 3,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            Toast.success(res.data.msg);
            var time = 60;
            that.disabled4 = true;
            that.emailCodeText = time + "s";
            window.timer2 = setInterval(function () {
              time--;
              that.emailCodeText = time + "s";
              if (time <= 0) {
                clearInterval(window.timer2);
                that.disabled4 = false;
                that.emailCodeText = "获取验证码";
              }
            }, 1000);
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },

    setEmail() {
      let that = this;
      if (that.inputEmailCode == "") {
        that.$message.error("请输入验证码");
      } else if (that.inputEmail == "") {
        that.$message.error("请输入邮箱");
      } else {
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "modify_email",
              token: sessionStorage.getItem("token"),
              email: that.inputEmail,
              code: that.inputEmailCode,
            },
          })
          .then(function (res) {
            if (res.data.code == 1) {
              that.$toast.success({
                message: res.data.msg,
                onClose: function () {
                  that.$router.push({
                    path: "/member/information",
                  });
                },
              });
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(res.data.msg);
            }
          });
      }
    },
    encryptMessage(message, publicKey) {
      const jsEncrypt = new JSEncrypt();
      jsEncrypt.setPublicKey(publicKey);
      return jsEncrypt.encrypt(message);
    },
    getUserPhone() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user_info",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.encryptedPhone = res.data.data.phone1;
          }
          else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
  },
  mounted: function () {
    let that = this;
    that.isLogin();
    this.getUserPhone();
  },
};
</script>

<style scoped>
.change_email_btn {
  position: fixed;
  bottom: 72px;
  width: 90%;
  margin-left: 3px;
  margin-bottom: 20px;
  font-size: 15px;
}
</style>
<style>
#changeEmail .van-field {
  background-color: #fafafa;
  margin: 20px;
  width: unset;
  border-radius: 10px;
}
#changeEmail .van-field__label {
  color:#7b7777 !important;
}
#changeEmail .van-field__control{
  color:#000000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/BindEmail.vue